/*
 * Ajustes de comportamiento de Serendipia Home.
 *
 * Misma regla que la hoja de estilos: aquí solo entra lo que no se puede
 * conseguir con un ajuste nativo de Horizon, y cada bloque explica por qué.
 */

(function () {
  'use strict';

  /*
   * Un solo destino por tarjeta en "Lo más vendido".
   *
   * Horizon envuelve la tarjeta destacada en cuatro enlaces al mismo producto:
   * una capa absoluta que la cubre entera, otro alrededor de la galería, otro
   * en el título y el botón. La capa hace que cualquier clic navegue, que es
   * justo lo que no se quiere cuando la tarjeta tiene su propio botón.
   *
   * No se resuelve con CSS. `pointer-events: none` corta el ratón pero deja el
   * enlace en el orden de tabulación y respondiendo a Enter, así que el teclado
   * y el ratón acabarían haciendo cosas distintas. Retirarlos del DOM es lo
   * único que deja las dos vías de acceso diciendo lo mismo.
   *
   * El enlace del snippet de Horizon es incondicional —no hay ajuste que lo
   * apague—, de ahí que se haga desde aquí y no editando el snippet, que es
   * lo que rompería las actualizaciones de upstream.
   */
  function dejarUnSoloEnlace(raiz) {
    var tarjetas = (raiz || document).querySelectorAll(
      '.section-resource-list .product-card'
    );

    Array.prototype.forEach.call(tarjetas, function (tarjeta) {
      // Sin botón propio no se toca nada: la tarjeta se quedaría sin destino.
      if (!tarjeta.querySelector('.tarjeta-cta')) return;

      var sobrantes = tarjeta.querySelectorAll(
        'a.product-card__link, a.contents'
      );

      Array.prototype.forEach.call(sobrantes, function (enlace) {
        if (enlace.classList.contains('tarjeta-cta')) return;

        // La capa absoluta no envuelve nada: se retira.
        // Los `display: contents` sí envuelven contenido visible, así que se
        // desmontan dejando dentro lo que tenían.
        var padre = enlace.parentNode;
        while (enlace.firstChild) padre.insertBefore(enlace.firstChild, enlace);
        padre.removeChild(enlace);
      });
    });
  }

  /*
   * Logotipo a dos tonos.
   *
   * El prototipo escribe la marca en dos colores: el nombre en tinta y la
   * última palabra en salvia. El bloque de logotipo de Horizon pinta
   * `shop.name` tal cual, sin forma de marcar una parte, y el CSS no sabe
   * seleccionar la última palabra de un texto.
   *
   * Se parte aquí. No se escribe ninguna palabra concreta: se acentúa la
   * última, sea la que sea, así que el día que cambie el nombre de la tienda
   * el logotipo sigue funcionando. Con un nombre de una sola palabra no hace
   * nada, porque teñir la marca entera no es un acento.
   */
  function acentuarLogo() {
    // Palabra de refuerzo, del ajuste "Palabra destacada del logotipo". Existe
    // porque el nombre de la tienda es una sola palabra —"Serendipia"— y la
    // marca son dos. Cambiarlo en Shopify tocaría correos, facturas y pago, y
    // el aspecto del theme no debería depender de eso.
    var etiqueta = document.querySelector('script[src*="serendipia.js"]');
    var refuerzo = etiqueta ? (etiqueta.dataset.logoAcento || '').trim() : '';

    var cabecera = document.querySelector('.header-logo > span');
    var marca = cabecera ? cabecera.textContent.trim() : '';

    var logos = [];
    if (cabecera) logos.push(cabecera);

    /*
     * En el pie la marca es un párrafo más entre otros, y no puede llevar
     * ninguna marca en su texto: Shopify sanea el richtext de los ajustes y
     * descarta los atributos de clase.
     *
     * La primera versión lo localizaba por estructura —el primer párrafo del
     * primer bloque— y al reordenar el pie ese selector pasó a coger también
     * el lema, que acabó terminando en "…tu día a día. Home". Así que ya no se
     * busca por dónde está sino por lo que dice: se acentúa lo que sea igual
     * al nombre de la tienda. Eso sobrevive a cualquier reordenación futura.
     */
    if (marca) {
      var parrafos = document.querySelectorAll(
        '.shopify-section-group-footer-group p'
      );
      Array.prototype.forEach.call(parrafos, function (p) {
        var texto = p.textContent.trim();
        if (texto === marca || texto === (marca + ' ' + refuerzo).trim()) {
          logos.push(p);
        }
      });
    }

    logos.forEach(function (logo) {
      if (logo.querySelector('.logo-acento')) return;

      var palabras = logo.textContent.trim().split(/\s+/);

      // Si el nombre ya acaba en esa palabra, se destaca la que hay en lugar
      // de añadir otra igual.
      if (
        refuerzo &&
        palabras[palabras.length - 1].toLowerCase() !== refuerzo.toLowerCase()
      ) {
        palabras.push(refuerzo);
      }

      if (palabras.length < 2) return;

      var acento = palabras.pop();

      logo.textContent = palabras.join(' ') + ' ';
      var marca = document.createElement('span');
      marca.className = 'logo-acento';
      marca.textContent = acento;
      logo.appendChild(marca);
    });
  }

  /*
   * "N personas viendo esto ahora mismo".
   *
   * EL NUMERO ES FALSO. No hay nadie contando: Shopify no expone visitantes
   * concurrentes al theme, y montarlo de verdad pediria un backend que contase
   * sesiones. Esto existe solo para la demo, con el theme en borrador, igual
   * que las valoraciones de muestra.
   *
   * ANTES DE PUBLICAR HAY QUE QUITARLO. Se quita entero borrando el bloque
   * `viendo_ahora_FICTICIO` de templates/product.json; esta funcion se queda
   * sin nada que hacer y no pinta nada. Un contador inventado dirigido a
   * apurar la compra es una practica comercial desleal, y la escasez y la
   * urgencia falsas estan expresamente senaladas como patron oscuro en las
   * guias de la Comision Europea.
   *
   * Dos decisiones sobre como se inventa el numero, por si alguien lo hereda:
   *
   * El valor se siembra con el id del producto en lugar de sortearse en cada
   * carga. Un aleatorio puro salta a otra cifra al recargar y al volver atras,
   * que es exactamente como se descubre que es mentira. Sembrado, cada
   * producto tiene su propia cifra y se mantiene.
   *
   * Y deriva de uno en uno cada medio minuto largo, no a saltos. El rango es
   * corto —de 4 a 15— porque en una tienda que acaba de abrir un "87 personas
   * viendo" no lo cree nadie.
   */
  function viendoAhora() {
    var nodos = document.querySelectorAll("[data-viendo]");
    if (!nodos.length) return;

    /*
     * Dos formulas con rangos distintos, y la diferencia no es cosmetica.
     *
     * "Viendo ahora mismo" es una foto de un instante: en una tienda pequena,
     * cuatro o quince. "Interesadas" es un acumulado, asi que puede ser mucho
     * mayor sin chirriar. Si los dos numeros saliesen del mismo rango, quien
     * pase de la portada a la ficha vera que no encajan.
     *
     * Los rangos de aqui son solo el respaldo. Los de verdad los elige quien
     * configura el theme, en Datos de demostracion, y llegan en los atributos
     * data-viendo-min y data-viendo-max.
     */
    var MODOS = {
      viendo: {
        min: 4,
        max: 15,
        uno: "1 persona viendo esto ahora mismo",
        varios: " personas viendo esto ahora mismo"
      },
      interes: {
        min: 12,
        max: 44,
        uno: "1 persona interesada",
        varios: " personas interesadas"
      }
    };

    // Un ajuste del editor puede llegar vacio, no numerico o con el minimo por
    // encima del maximo. Nada de eso debe pintar "NaN personas viendo esto",
    // asi que cada valor se valida y se cae al respaldo si no sirve.
    function numero(valor, respaldo) {
      var n = parseInt(valor, 10);
      return isNaN(n) || n < 1 ? respaldo : n;
    }

    Array.prototype.forEach.call(nodos, function (nodo) {
      var texto = nodo.querySelector(".viendo-ahora__texto");
      if (!texto) return;

      var base = MODOS[nodo.dataset.viendoModo] || MODOS.viendo;

      var min = numero(nodo.dataset.viendoMin, base.min);
      var max = numero(nodo.dataset.viendoMax, base.max);
      // Rango invertido: se enderezan en vez de no pintar nada. Quien mueve
      // dos deslizadores acaba cruzandolos, y el resultado no deberia ser una
      // linea en blanco sin explicacion.
      if (max < min) { var t = min; min = max; max = t; }

      var modo = { min: min, max: max, uno: base.uno, varios: base.varios };

      // La semilla mezcla el id y el modo, para que el mismo producto no
      // ensene la misma cifra en la portada y en la ficha.
      var semilla = 0;
      var id = String(nodo.dataset.viendo || "") + ":" + (nodo.dataset.viendoModo || "viendo");
      for (var i = 0; i < id.length; i++) {
        semilla = (semilla * 31 + id.charCodeAt(i)) % 100000;
      }

      var valor = modo.min + (semilla % (modo.max - modo.min + 1));

      function pintar() {
        texto.textContent = valor === 1 ? modo.uno : valor + modo.varios;
      }

      function derivar() {
        valor += Math.random() < 0.5 ? -1 : 1;
        if (valor < modo.min) valor = modo.min + 1;
        if (valor > modo.max) valor = modo.max - 1;
        pintar();
        // Intervalo irregular: uno fijo se nota en cuanto miras dos veces.
        setTimeout(derivar, 26000 + Math.random() * 22000);
      }

      pintar();
      nodo.hidden = false;
      setTimeout(derivar, 18000 + Math.random() * 16000);
    });
  }

  /*
   * Dos remiendos al carrusel cuando pasa solo.
   *
   * El componente de Horizon ya se para al pasar el raton por encima y con la
   * pestana en segundo plano, pero le faltan dos cosas que solo se notan
   * cuando el paso automatico esta encendido:
   *
   * 1. No se para al recibir el foco del teclado. Quien navega tabulando por
   *    las resenas se encuentra con que el contenido se mueve debajo mientras
   *    lo lee, y ese es justo el caso que cubre el criterio 2.2.2 de las WCAG
   *    -"Poner en pausa, detener, ocultar"-. El raton se salva por el :hover;
   *    el teclado no tiene equivalente.
   *
   * 2. No mira prefers-reduced-motion. Hay gente que desactiva las
   *    animaciones porque el movimiento le marea o le dispara sintomas, y un
   *    carrusel que avanza solo es exactamente eso.
   *
   * Se arregla aqui y no en slideshow.js para no tocar un archivo de Horizon
   * que se sobrescribe en cada actualizacion del theme.
   */
  function carruselAccesible() {
    if (!window.customElements || !window.matchMedia) return;

    customElements.whenDefined('slideshow-component').then(function () {
      // Solo los que pasan solos: el resto ya se controlan a mano.
      var carruseles = document.querySelectorAll('slideshow-component[autoplay]');
      if (!carruseles.length) return;

      var quietud = window.matchMedia('(prefers-reduced-motion: reduce)');

      Array.prototype.forEach.call(carruseles, function (carrusel) {
        if (typeof carrusel.pause !== 'function') return;

        /*
         * De una en una, no de cuatro en cuatro.
         *
         * Horizon avanza tantas fichas como quepan a la vez: con cuatro
         * columnas, la pagina entera cambia de golpe y no queda nada donde
         * apoyar la vista. De una en una el movimiento se lee como
         * continuo, que es lo que se pidio.
         *
         * Se define sobre el elemento y no se toca slideshow.js: una
         * propiedad propia tapa la del prototipo, asi que next() y
         * previous() leen esta y el archivo de Horizon se queda intacto para
         * la proxima actualizacion.
         */
        /*
         * La ultima ficha a la que tiene sentido ir NO es la octava.
         *
         * Con cuatro columnas visibles y ocho fichas, el carril deja de
         * avanzar en la quinta: a partir de ahi las posiciones 6, 7 y 8 se ven
         * exactamente igual, porque ya no queda a donde desplazarse. Sin esto,
         * el carrusel pasaria dieciocho segundos aparentemente congelado antes
         * de volver al principio, que se lee como averiado.
         *
         * Se calcula con la geometria real y no con visibleSlides: eso ultimo
         * lo alimenta un IntersectionObserver, que no dispara con la pestana
         * en segundo plano y devolveria cero.
         */
        function ultimaUtil() {
          var fichas = carrusel.slides;
          if (!fichas || !fichas.length) return 0;

          var carril = carrusel.querySelector('slideshow-slides');
          var ancho = fichas[0].getBoundingClientRect().width;
          if (!carril || !ancho) return fichas.length - 1;

          // Cuantas caben enteras a la vez. El +1 de tolerancia evita que un
          // redondeo de un pixel quite una ficha de la cuenta.
          var caben = Math.floor((carril.clientWidth + 1) / ancho);
          if (caben < 1) caben = 1;

          return Math.max(0, fichas.length - caben);
        }

        Object.defineProperty(carrusel, 'nextIndex', {
          configurable: true,
          get: function () {
            var siguiente = this.current + 1;
            return siguiente > ultimaUtil() ? 0 : siguiente;
          },
        });
        Object.defineProperty(carrusel, 'previousIndex', {
          configurable: true,
          get: function () {
            var anterior = this.current - 1;
            return anterior < 0 ? ultimaUtil() : anterior;
          },
        });

        /*
         * Sin flechas, el teclado se queda sin manera de avanzar: las fichas
         * de resena son texto, no llevan ni un enlace ni un boton dentro, asi
         * que no hay nada que enfocar. Con el paso automatico casi da igual
         * -las ocho acaban pasando solas-, pero con prefers-reduced-motion
         * activado el carrusel no se mueve y solo se verian las cuatro
         * primeras, sin salida.
         *
         * Un contenedor con scroll y tabindex si es operable con el teclado:
         * se enfoca con el tabulador y se recorre con las flechas del
         * teclado. Firefox lo hace solo con las regiones desplazables;
         * Chrome no, hay que pedirlo.
         */
        var carril = carrusel.querySelector('slideshow-slides');
        if (carril && carril.getAttribute('tabindex') !== '0') {
          // Horizon ya le pone tabindex="-1" para poder enfocarlo por codigo
          // tras cambiar de ficha. Eso no lo hace alcanzable con el tabulador,
          // que es lo que hace falta aqui, asi que se sube a 0.
          carril.setAttribute('tabindex', '0');
          if (!carril.hasAttribute('aria-label')) {
            carril.setAttribute('role', 'group');
            carril.setAttribute('aria-label', 'Reseñas de clientes');
          }
        }

        /*
         * Horizon pone aria-live="polite" junto al autoplay, y esa
         * combinacion es justo la que no hay que hacer: cada seis segundos un
         * lector de pantalla anuncia la resena que acaba de entrar, sin que
         * nadie se lo haya pedido y sin parar nunca. La region viva se apaga
         * mientras el carrusel se mueve solo y se enciende cuando esta
         * quieto, que es cuando un cambio SI responde a algo que ha hecho
         * quien navega y merece anunciarse.
         */
        function avisar(encendido) {
          carrusel.setAttribute('aria-live', encendido ? 'polite' : 'off');
        }

        function segunPreferencia() {
          if (quietud.matches) {
            // pause() marca el carrusel como pausado, asi que ni el foco ni
            // nada lo vuelven a arrancar mientras la preferencia siga puesta.
            carrusel.pause();
            avisar(true);
          } else if (carrusel.paused) {
            carrusel.paused = false;
            carrusel.play();
            avisar(false);
          } else {
            avisar(false);
          }
        }

        segunPreferencia();
        if (quietud.addEventListener) {
          quietud.addEventListener('change', segunPreferencia);
        }

        // suspend() detiene el temporizador sin marcarlo como pausado, que es
        // lo que hace falta aqui: es una parada temporal mientras se lee.
        carrusel.addEventListener('focusin', function () {
          carrusel.suspend();
          avisar(true);
        });

        carrusel.addEventListener('focusout', function (evento) {
          // Moverse entre dos fichas del mismo carrusel no es salir de el.
          if (carrusel.contains(evento.relatedTarget)) return;
          carrusel.resume();
          if (!carrusel.paused) avisar(false);
        });
      });
    });
  }

  function arrancar() {
    dejarUnSoloEnlace();
    acentuarLogo();
    viendoAhora();
    carruselAccesible();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // El personalizador vuelve a pintar la sección con cada cambio y devuelve
  // los enlaces originales.
  document.addEventListener('shopify:section:load', function (evento) {
    dejarUnSoloEnlace(evento.target);
  });
})();
